module.exports = __webpack_public_path__ + "img/icon-user-cat.63599b2f.png";